import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { setHideMoney } from "@/lib/format";

const AuthContext = createContext(null);

export const PANELS = [
  { id: "dashboard", path: "/", label: "Panoramica" },
  { id: "ordini", path: "/ordini", label: "Ordini" },
  { id: "clienti", path: "/clienti", label: "Clienti" },
  { id: "magazzino", path: "/magazzino", label: "Prodotti" },
  { id: "resi", path: "/resi", label: "Resi" },
  { id: "produzione", path: "/produzione", label: "Produzione" },
  { id: "materie_prime", path: "/materie-prime", label: "Materie prime" },
  { id: "modellistica", path: "/modellistica", label: "Modellistica" },
  { id: "richieste", path: "/richieste", label: "Richieste clienti" },
  { id: "social", path: "/social", label: "Social" },
  { id: "logistica", path: "/logistica", label: "Logistica" },
  { id: "attivita", path: "/attivita", label: "Registro attività" },
];

export const seesMoney = (user) => user?.role === "admin" || !!user?.see_financials;
export const canSee = (user, panel) => user?.role === "admin" || (panel === "vendite" && !!user?.see_financials) || (user?.panels || []).includes(panel);

export function AuthProvider({ children }) {
  const [user, setUserState] = useState(null); // null = checking, false = anon, object = auth
  const setUser = (u) => { setHideMoney(!!u && !seesMoney(u)); setUserState(u); };

  useEffect(() => {
    localStorage.removeItem("moda_token");
    api.get("/auth/me").then((res) => setUser(res.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
